import { LegalEntityEnum } from '../legal-entity.enum';
import { CaseImageType } from './case-image-type.enum';
import { IMAGE_UPLOAD_REQUIRED_LEGAL_ENTITIES, REQUIRED_WARRANTY_IMAGE_TYPES } from './case.constants';
import { ProductMainGroups } from './product-main-group.enum';

export const isWarrantyImageUploadRequired = (legalEntity?: LegalEntityEnum | string): boolean => {
  if (!legalEntity) {
    return false;
  }

  return IMAGE_UPLOAD_REQUIRED_LEGAL_ENTITIES.has(legalEntity as LegalEntityEnum);
};

export const areWarrantyLineImagesValid = (
  images: { imageType?: CaseImageType }[] | undefined,
  productMainGroup?: ProductMainGroups | string,
): boolean => {
  if (!productMainGroup) {
    return false;
  }

  const requiredImageTypes = REQUIRED_WARRANTY_IMAGE_TYPES[productMainGroup as ProductMainGroups];
  if (!requiredImageTypes) {
    return false;
  }

  // Defensive guard: no current entry in REQUIRED_WARRANTY_IMAGE_TYPES is empty, so this
  // branch is unreachable today. It's kept in case a future legal entity/product group
  // combination requires zero images, so that case is explicitly valid rather than falling
  // through to the length checks below.
  if (requiredImageTypes.length === 0) {
    return true;
  }

  if (!images || images.length < requiredImageTypes.length) {
    return false;
  }

  const uploadedImageTypes = new Set(images.map((eachImage) => eachImage.imageType));

  return requiredImageTypes.every((requiredImageType) => uploadedImageTypes.has(requiredImageType));
};
